import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #ffa800;
  width: 35px;
  height: 35px;
`

export const UserCircledIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 36 35">
      <circle cx="17.9998" cy="17.0625" r="16.1875" />
      <path d="M17.8167 18.0568C22.9354 18.0568 27.3775 20.956 29.5913 25.1997C31.2304 22.8635 32.1958 20.0168 32.1958 16.9456C32.1958 9.00349 25.7588 2.56641 17.8167 2.56641C9.87458 2.56641 3.4375 9.00349 3.4375 16.9456C3.4375 20.0168 4.4 22.8635 6.04208 25.1997C8.25292 20.9531 12.695 18.0568 17.8167 18.0568Z" />
      <path
        d="M17.8166 31.3246C22.6874 31.3246 26.9924 28.9037 29.5911 25.1996C27.3774 20.9558 22.9353 18.0566 17.8166 18.0566C12.6978 18.0566 8.25281 20.9529 6.03906 25.1996C8.64073 28.9037 12.9457 31.3246 17.8166 31.3246Z"
        fill="white"
      />
      <path
        d="M17.8166 16.6663C20.6967 16.6663 23.0316 14.3315 23.0316 11.4513C23.0316 8.57116 20.6967 6.23633 17.8166 6.23633C14.9364 6.23633 12.6016 8.57116 12.6016 11.4513C12.6016 14.3315 14.9364 16.6663 17.8166 16.6663Z"
        fill="white"
      />
    </Svg>
  )
}
